import { useEffect, useRef } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { reconstructionShareUrl } from './components/ReconstructionShareCard';
import { AdminPage } from './pages/AdminPage';
import { HomePage } from './pages/HomePage';
import { TestLandingPage } from './pages/TestLandingPage';

function LegacyReconstructionRedirect() {
  const { shareToken = '' } = useParams();
  const target = reconstructionShareUrl(shareToken);
  const redirectStarted = useRef(false);

  useEffect(() => {
    if (redirectStarted.current) return;
    redirectStarted.current = true;
    window.location.replace(target);
  }, [target]);

  return (
    <main
      data-testid="legacy-reconstruction-redirect"
      className="flex min-h-screen items-center justify-center bg-slate-50 p-6 text-center"
      dir="rtl"
    >
      <p className="text-slate-600">
        מעבירים אתכם לשחזור…{' '}
        <a className="font-semibold text-primary-700" href={target}>לחצו כאן אם לא הועברתם</a>
      </p>
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/reconstruct/:shareToken" element={<LegacyReconstructionRedirect />} />
        <Route path="/:slug" element={<TestLandingPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
